interface ViewTransitionLike {
  ready?: Promise<unknown>;
  finished?: Promise<unknown>;
  updateCallbackDone?: Promise<unknown>;
}
type DocWithVT = Document & { startViewTransition?: (cb: () => unknown) => ViewTransitionLike | undefined };

/**
 * Ejecuta [update] con la View Transitions API cuando se puede animar. Sin
 * soporte, con la pestaña oculta o con "reducir movimiento" corre directo. El
 * navegador cancela la transicion si la pestaña se oculta a mitad: esas
 * promesas rechazadas se silencian (el cambio igual se aplica) para que no
 * terminen como "UnhandledRejection" en el monitor.
 */
export function withViewTransition(update: () => unknown): void {
  const doc = document as DocWithVT;
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if (!doc.startViewTransition || reduced || document.visibilityState !== 'visible') {
    void update();
    return;
  }
  const transition = doc.startViewTransition(update);
  for (const p of [transition?.ready, transition?.finished, transition?.updateCallbackDone]) p?.catch(() => undefined);
}
